export default __webpack_public_path__ + "static/media/new-folder.c244fa11.svg";